import { Grid, FormControl } from "@mui/material";
import { PropsWithChildren } from "react";

const FormField = ({ children }: PropsWithChildren) => {
    return (
        <Grid size={{ xs: 12, md: 6 }} sx={{padding: '1rem', width: "100%"}}>
            <FormControl sx={{ width: "100%" }}>
                {children}
            </FormControl>
        </Grid>
    );
}

export default FormField;